export default "__VITE_ASSET__Eprcb$Nk__"